{
	"captcha-valid": "Required",
	"name-length": "Name can only be 12 characters long",
	"companyDebitForm": "Company debit form",
	"countLetters": "Count letters?",
	"email": "Email",
	"email-format": "Has to be email",
	"input": "Input number of letters to send",
	"validateMultiple": "Requires at least one field filled",
	"name": "Name",
	"nameOfCompany": "Name of company",
	"numberOfEuropeanLetters": "Number of European letters",
	"numberOfLettersOutsideEurope": "Number of letters outside Europe",
	"numberOfRegularLetters": "Number of regular letters",
	"numberOfRegisteredLetters": "Number of registered letters",
	"numberslength": "Max length is 5 digits",
	"onlyNumbers": "Only numbers allowed",
	"greaterThanZero": "Value must be greater than 0",
	"reference": "Reference",
	"register": "Register",
	"required": "Field is required",
	"socialId": "Social Id",
	"socialIdMinimum": "Must be at least 9 digits",
	"socialIdMax": "Social Id can't be longer than 10 digits",
	"socialIdRequired": "Field is required",
	"socialIdValid": "Not a valid social Id - please contact us at 5801300 or send us an email at fjarstyring@postur.is"
}
